module.exports = __webpack_public_path__ + "3c22f16b.svg";